import React, { forwardRef } from "react";
import styles from "./vertical-form-input-field.module.css";

const VerticalFormInputField = forwardRef((props, ref) => {
  const {
    value,
    onChange,
    title,
    hint,
    inputType = "text",
    inputName,
    inputId,
    pattern,
    min,
    max,
    className = "",
    inputClassName,
    requireFocus,
    showShadow = true,
    required = false,
    style,
    ...restprops
  } = props;

  return (
    <div className={`${styles.formContainer} ` + className} style={style}>
      <label htmlFor={inputId} className={styles.label}>
        {title}
        <span style={{ color: "#931b1c", fontWeight: 600 }}>{`${
          required ? "*" : ""
        }`}</span>
      </label>
      <input
        ref={ref}
        name={inputName}
        id={inputId}
        type={inputType}
        value={value}
        pattern={pattern}
        className={`${styles.input}  ${
          showShadow && "boxShadow-md "
        } ${inputClassName}`}
        onChange={onChange}
        placeholder={hint}
        min={min}
        max={max}
        {...restprops}
      />
    </div>
  );
});

export default VerticalFormInputField;
